import { render, staticRenderFns } from "./mobile_trading.vue?vue&type=template&id=2cd2d4c4&scoped=true&"
import script from "./mobile_trading.vue?vue&type=script&lang=js&"
export * from "./mobile_trading.vue?vue&type=script&lang=js&"
import style0 from "./mobile_trading.vue?vue&type=style&index=0&id=2cd2d4c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2d4c4",
  null
  
)

export default component.exports